// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"5f2218f9","6923":"5f2218f9","8062":"5f2218f9"}[chunkId] + ".chunk.css";
};